export default "__VITE_ASSET__B3x8Fgv9__"